import { render, staticRenderFns } from "./SelectSeatNew.vue?vue&type=template&id=bcf93782&scoped=true&"
import script from "./SelectSeatNew.vue?vue&type=script&lang=js&"
export * from "./SelectSeatNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectSeatNew.vue?vue&type=style&index=0&id=bcf93782&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf93782",
  null
  
)

export default component.exports